import { genericFetch } from "./common-service"
import { apiBaseUrl } from "./config"
import { LOCAL_AUTHORITIES, LOANS } from "./constant/url-segment"
import { getBaseHeader } from "./utils"
import { LocalAuthority, Loan } from "../../model"
import { createLoanRequestBody } from "./factory";

export function createLoan(loan: Loan): Promise<Loan> {
	const url = `${apiBaseUrl}/${LOCAL_AUTHORITIES}/${loan.localAuthority.id}/${LOANS}`
	const init: RequestInit = {
		body: JSON.stringify(createLoanRequestBody(loan)),
		headers: {
			...getBaseHeader(),
			"Content-Type": "application/json"
		},
		method: "POST"
	}

	return genericFetch<Loan>(url, init)
}

export function deleteLoan(loan: Loan): Promise<void> {
	const url = `${apiBaseUrl}/${LOCAL_AUTHORITIES}/${loan.localAuthority.id}/${LOANS}/${loan.id}`
	const init: RequestInit = {
		headers: getBaseHeader(),
		method: "DELETE"
	}

	return genericFetch<void>(url, init)
}

export function findLoanById(
	localAuthority: LocalAuthority,
	loanId: number
	): Promise<Loan> {
		const url = `${apiBaseUrl}/${LOCAL_AUTHORITIES}/${localAuthority.id}/${LOANS}/${loanId}`
		const init: RequestInit = { headers: getBaseHeader() }

		return genericFetch<Loan>(url, init)
		.then(parseLoanDates)
}

export function findLoans(localAuthority: LocalAuthority): Promise<Loan[]> {
	const url = `${apiBaseUrl}/${LOCAL_AUTHORITIES}/${localAuthority.id}/${LOANS}`
	const init: RequestInit = { headers: getBaseHeader() }

	return genericFetch<Loan[]>(url, init)
	.then(loans => loans.map(parseLoanDates))
}


export function findAllLoans(localAuthority: LocalAuthority): Promise<any> {
	const url = `${apiBaseUrl}/${LOCAL_AUTHORITIES}/${localAuthority.id}/all/${LOANS}`
	const init: RequestInit = { headers: getBaseHeader() }

	return genericFetch(url, init)
	.then(l =>{
		let obj:any = l
		let data =[]
		let name = []
		for (let allLoan in obj) {
			data.push(obj[allLoan].map(parseLoanDates))
			name.push(allLoan)
	}
	let finalData =[data,name]
	return finalData
} )
}

export function updateLoan(loan: Loan): Promise<Loan> {
	const url = `${apiBaseUrl}/${LOCAL_AUTHORITIES}/${loan.localAuthority.slug}/${LOANS}/${loan.id}`
	const init: RequestInit = {
		body: JSON.stringify(createLoanRequestBody(loan)),
		headers: {
			...getBaseHeader(),
			"Content-Type": "application/json"
		},
		method: "PUT"
	}

	return genericFetch<Loan>(url, init).then(parseLoanDates)
}

function parseLoanDates(loan: Loan): Loan {
	loan.contractedOn = new Date(loan.contractedOn)
	return loan
}



// WEBPACK FOOTER //
// ./src/service/sfp/loans-service-2.ts